<template>
  <div class="app-content">
    <transition name="el-fade-in-linear">
      <div v-show="promptShow" class="back">
        <div v-show="promptShow" class="copyLink">
          <h1>提示</h1>
          <p>{{ promptContent }}</p>
          <button v-if="promptValue == 'copy'" @click="copyLink">复 制</button>
          <button v-else @click="promptShow = false">确 定</button>
        </div>
      </div>
    </transition>

    <div class="center">
      <!-- <div class="downloadButton" @click="download">立即下载</div> -->
    </div>
    <div class="zhezhao" v-if="dialog">
      <img src="../../assets/images/zhezhao.png" alt="">
    </div>
  </div>
</template>
<script>
// import mui from 'mui'
import store from '@/store'
export default {
  name: "download",
  data() {
    return {
      promptShow: false,
      promptValue: '',
      promptContent: '',
      timer: null,
      dialog: false
    }
  },
  created() {
    store.dispatch('settings/setTitle', '银成圣云执业医师考试')
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      // this.ejectPrompt('copy')
      this.dialog = true
    } else {
      this.download()
      // this.closeWeb()
    }
  },
  // mounted(){
  // 	const timer = setTimeout(() => {
  // 		console.log('11111');
  // 		// this.download();
  // 		alert('提示')
  // 	}, 3000);
  // 	document.addEventListener("visibilitychange", visibilitychange, false);
  // 	document.addEventListener("webkitvisibilitychange", visibilitychange, false);
  // 	window.addEventListener("pagehide",function() {
  // 		clearTimeout(timer);
  // 	},
  // 	false
  // 	)
  // 	function visibilitychange() {
  // 		const tag = document.hidden || document.webkitHidden;
  // 		tag && clearTimeout(timer);
  // 	}

  // },
  methods: {
    ejectPrompt(val, content) {
      if (val == 'copy') {
        this.promptContent = '请复制链接地址，去外部浏览器中打开'
        this.promptShow = true
        this.promptValue = val
      } else {
        this.promptContent = content
        this.promptShow = true
        this.promptValue = val
      }
    },

    copyLink() {
      let copyInput = document.createElement("input"); // 创建元素
      // 这边为链接地址
      copyInput.value = window.location.href;
      document.body.appendChild(copyInput); // 添加元素
      copyInput.select();
      document.execCommand("Copy"); // 执行浏览器复制命令
      document.body.removeChild(copyInput); // 移除刚创建的元素
      this.$message.success("复制成功");
      this.promptShow = false
    },

    download() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.ejectPrompt('copy')
      } else {
        if (this.judgeClient() == 'Android') {
          //   window.location.href = 'https://file.medmeta.com/static/20231129/doctorapp.apk'
          //   window.location.href = 'oppomarket://details?packagename=com.yddmi.doctor'
          window.location.href = this.getPhoneType()
        } else if (this.judgeClient() == 'IOS') {
          window.location.href = 'https://apps.apple.com/us/app/id6469769193'
          // this.ejectPrompt('prompt','暂未上架苹果商店，敬请期待')
        } else {

        }
      }
    },
//判断手机型号
    getPhoneType(){
      let userAgent = navigator.userAgent;
      let brand = 'unknown';
      let href = 'https://sj.qq.com/appdetail/com.yddmi.doctor'//应用宝地址
      // let href = 'oppomarket://details?packagename=com.yddmi.doctor'//应用宝地址
      if(/iPhone|iPad/i.test(userAgent)){
        brand = 'Apple'
        href = 'https://apps.apple.com/us/app/id6469769193'
      }else if(/HUAWEI/i.test(userAgent)){
        brand = 'HUAWEI'
        href = 'appmarket://details?id=com.yddmi.doctor'
      }else if(/honor/i.test(userAgent)){
        brand = 'honor'
        href = 'appmarket://details?id=com.yddmi.doctor'
      }else if(/Xiaomi/i.test(userAgent)){
        brand = 'Xiaomi';
        href = 'mimarket://details?id=com.yddmi.doctor'
      }else if(/SamSung/i.test(userAgent)){
        brand = 'SamSung'
        href = 'samsungapps://ProductDetail/com.yddmi.doctor'
      }else if(/vivo/i.test(userAgent)){
        brand = 'vivo'
        href = 'vivomarket://details?id=com.yddmi.doctor'
      }else if(/HeyTapBrowser/i.test(userAgent)){
        brand = 'oppo'
        href = 'oppomarket://details?packagename=com.yddmi.doctor'
      }
      return href
    },
    closeWeb() {
      // alert(this.judgeClient())
      if (this.judgeClient() == 'Android') {
        this.closeWebAndroid()
      } else if (this.judgeClient() == 'IOS') {
        this.closeWebIOS()
      } else {

      }
    },

    closeWebAndroid() {
      if (this.$route.query.shareCode) {
        window.location.href = 'openapp://syyxcloud.com.doctor?shareCode=' + this.$route.query.shareCode
      } else {
        window.location.href = 'openapp://syyxcloud.com'
      }
    },

    closeWebIOS() {
      if (this.$route.query.shareCode) {
        window.location.href = 'ydd9528://app/shareToLogin?shareCode=' + this.$route.query.shareCode
      } else {
        window.location.href = 'ydd9528://'
      }
    },

    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;   //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);  //判断是否是 iOS终端
      if (isAndroid) {
        return 'Android';
      } else {
        return 'IOS';
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.app-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  .back {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 14, 14, 0.5);
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(1px);

    .copyLink {
      width: 7.7333rem;
      // height: 4.8rem;
      // background-color: #fff;
      background: url('../../assets/images/promptBack.png') no-repeat;
      background-size: 100%;
      border-radius: .1067rem;

      h1 {
        font-size: .4267rem;
        font-weight: 600;
        margin-top: .32rem;
        color: #000000;
        line-height: 18px;
        padding: 0 .4rem 0 .4rem;
        text-align: center;
      }

      p {
        height: 1.8133rem;
        font-size: .4267rem;
        margin-top: .2133rem;
        color: #000000;
        padding: .2667rem .48rem .2667rem .48rem;
        text-align: center;
      }

      button {
        width: 100%;
        height: 1.3333rem;
        // margin-top: .2667rem;
        border: 0;
        // border-top: 1px solid #efefef;
        border-radius: 0rem;
        background-color: #ffffff00;
        font-size: .48rem;
        font-weight: 600;
        color: #013EDC;
        border-radius: 0 0 .1067rem .1067rem;
      }
    }
  }

  .center {
    width: 100%;
    height: 100vh;
    background: url('../../assets/images/downloadBack.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;

    .downloadButton {
      width: 6.8533rem;
      height: 1.28rem;
      background: url('../../assets/images/downloadButton.png') no-repeat;
      background-size: 100%;
      font-size: 20px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 1.2267rem;
      text-align: center;
      position: fixed;
      bottom: .5rem;
    }
  }

  .zhezhao {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
